query Company($id: String) {
  company(id: $id) {
    id
    name
    mailProvider
    customWording {
      salutation
      farewell
    }
    links {
      website
    }
    address {
      street
      city
      zip
      country
    }
    ambassador {
      id
      firstname
      lastname
      name
      role
      email
      phone
      mobile
      image {
        url
        id
      }
      signature {
        customTemplateSignature
        text
        html
        extra
        includeGoogleReview
        includeProvenExpert
      }
    }
  }
}
